var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockComments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 53 52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V34.0217C0 36.2309 1.79086 38.0217 4 38.0217H14.9782L14.9783 50.5858C14.9783 51.4767 16.0555 51.9229 16.6854 51.2929L29.9565 38.0217H49C51.2091 38.0217 53 36.2309 53 34.0217V4C53 1.79086 51.2091 0 49 0H4ZM26.5 23C28.433 23 30 21.433 30 19.5C30 17.567 28.433 16 26.5 16C24.567 16 23 17.567 23 19.5C23 21.433 24.567 23 26.5 23ZM44 19.5C44 21.433 42.433 23 40.5 23C38.567 23 37 21.433 37 19.5C37 17.567 38.567 16 40.5 16C42.433 16 44 17.567 44 19.5ZM12.5 23C14.433 23 16 21.433 16 19.5C16 17.567 14.433 16 12.5 16C10.567 16 9 17.567 9 19.5C9 21.433 10.567 23 12.5 23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockComments);
export default __webpack_public_path__ + "static/media/block_comments.5accfc291b01aea1c499bf2c6795e9ec.svg";
export { ForwardRef as ReactComponent };